export default __webpack_public_path__ + "assets/images/50479164dc742f9b4a0c574c5adc1f93.png";